import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

const isDatasharesResultItem = objectOf({
  app_group_id: string,
  snowflake_account: string,
  platform_cluster: string,
  region: string,
  provider: string,
  tier: maybe(number),
});

export const isGetDatasharesResult = objectOf({
  datashares: arrayOf(isDatasharesResultItem),
  default_snowflake_provider: string,
  default_snowflake_region: string,
  total_data_share_entitlements: number,
  total_data_share_crr_entitlements: number,
  used_data_share_entitlements: number,
  used_data_share_crr_entitlements: number,
  total_tier1_entitlements: number,
  used_tier1_entitlements: number,
  total_tier2_entitlements: number,
  used_tier2_entitlements: number,
  total_tier3_entitlements: number,
  used_tier3_entitlements: number,
});
